// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0e6443f","239":"35480e24","557":"34ee06a6","732":"ed9e7104","762":"efad7498"}[chunkId] + ".chunk.js";
};